export default __webpack_public_path__ + "static/media/md-card-bg-track-multi-cloud.1a11cef7.png";